import PropTypes from 'prop-types';
import React from 'react';
import TourHeader from './TourHeader';
import ProposalTable from './ProposalTable';
import Loading from '../../../components/Loading';

class BookingDetail extends React.Component {

  componentDidMount() {
    if (this.props.needFetch) {
      this.props.requestBooking(this.props.id);
    }
    console.log('BookingDetail props: ', this.props);
  }

  render() {
    if (this.props.needFetch || this.props.isFetching) {
      return (<Loading />);
    }
    return (
      <div className="container-fluid">
        <div className="row tour-head">
          <div className="col-md-12 tour-headText">
            <h2>Booking Request</h2>
            <hr />
          </div>
        </div>
        <TourHeader tour={this.props.request.tour} 
          profilename={this.props.user}/>
        <div className="row">
          <div className="panel proposal-header planner col-md-12">
            <ProposalTable
              profilename={this.props.user}
              proposal={this.props.request}
              editBid={this.props.editBid}
              addBidNote={this.props.addBidNote}
              sendBid={this.props.sendBid}
              detail={this.props.detail}
              user={this.props.user}
              saveBidDetailsRates={this.props.saveBidDetailsRates}
              requestBidDetails={this.props.requestBidDetails}
              requestAnswers={this.props.requestAnswers}
              answers={this.props.selectedAnswers}
              addAnswers={this.props.addAnswers}
              addNotesBrand={this.props.addNotesBrand}
              getNotesBrand={this.props.getNotesBrand}
              changeBrandStatus={this.props.changeBrandStatus}
              updateHotelContacts={this.props.updateHotelContacts}
              deleteHotelContacts={this.props.deleteHotelContacts}
            />
          </div>
        </div>
      </div>);
  }
}

BookingDetail.propTypes = {
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  detail: PropTypes.string,
  requestBooking: PropTypes.func.isRequired,
  editBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  tour: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag_line: PropTypes.string.isRequired,
    image: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    created_on: PropTypes.string,
    updated_on: PropTypes.string,
    state: PropTypes.string.required,
    sent_to_manager: PropTypes.string,
    travel_agency: PropTypes.number,
    groups: PropTypes.arrayOf(PropTypes.object).required,
    members: PropTypes.arrayOf(PropTypes.object).required,
    routes: PropTypes.arrayOf(PropTypes.object).required,
    notes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

BookingDetail.defaultProps = {
  tour: {
    state: 'draft',
    start: null,
    end: null,
    image: 'https://www.whyy.org/img/ontour_logocrop.png',
    groups: [],
    members: [],
    routes: [],
  },
  detail: null,
};

export default BookingDetail;



// WEBPACK FOOTER //
// src/routes/booking/components/BookingDetail.js